import { Injectable, NgZone } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class GeolocationService {
  constructor(private http: HttpClientService, private httpClient: HttpClient, private ngZone: NgZone) {}

  public getLocation(address: string, geocoder: any): Observable<any> {
    return new Observable((observer) => {
      geocoder.geocode(
        {
          address: address,
          componentRestrictions: {
            country: "MX",
          },
        },
        (results, status) => {
          this.ngZone.run(() => {
            if (status == "OK") {
              observer.next(results);
              observer.complete();
            } else {
              observer.next(null);
              observer.complete();
            }
          });
        }
      );
    });
  }

  public getLocationByLatlng(latlng: any, geocoder: any): Observable<any> {
    return new Observable((observer) => {
      geocoder.geocode(
        {
          location: latlng,
        },
        (results, status) => {
          this.ngZone.run(() => {
            if (status == "OK") {
              observer.next(results);
              observer.complete();
            } else {
              observer.next(null);
              observer.complete();
            }
          });
        }
      );
    });
  }

  public getLocationByIP(): Observable<IpInfo> {
    // free tier are limited to 50k requests per month
    // https://ipinfo.io/developers
    return this.httpClient
      .get<IpInfo>("https://ipinfo.io/json")
      .pipe(tap((_) => console.log("GeolocationService.getLocationByIP: Ok.")));
  }

  public getPostalCode(postal_code: string, closest?): Observable<any[]> {
    const options = {
      params: {
        closest: closest,
      },
    };
    return this.http
      .get("/api/postal_codes/" + postal_code, options)
      .pipe(tap((_) => console.log("GeolocationService.getPostalCode: Ok.")));
  }

  public retrieveLocationsWithIds(postal_code: string): Observable<any[]> {
    return this.http
      .get("/api/postal_codes/" + postal_code + "/retrieve_locations_with_ids")
      .pipe(tap((_) => console.log("GeolocationService.retrieveLocationsWithIds: Ok.")));
  }
}

export interface IpInfo {
  ip: string;
  hostname: string;
  city: string;
  region: string;
  country: string;
  loc: string; //  "lat,lng"
  org: string;
  postal: string;
  timezone: string;
  readme: string;
}
